// extracted by mini-css-extract-plugin
export default {"errors":"PFZ10","compact":"P1q50","error":"PwQy5"};